/* eslint-disable react/no-array-index-key */
import React, { FC, useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import Table from 'components/Elements/Table';
// import { Table } from 'antd';
import { DailyVisit } from 'pages/SecurityDashboard/types';
import './securityVisitList.scss';

import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, CombinedStates } from 'core/types';
import moment from 'moment';
import { securityDashboardRequest } from 'core/securityDashboard/securityDashboardApi';
import ViewDetailsModal from '../SecurityInfoBlock/ViewDetailsModal';

export interface SecurityVisitListProps {
    visitData: DailyVisit[];
}

const SecurityVisitList: FC<SecurityVisitListProps> = ({ visitData }) => {
    const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
    const [modalData, setModalData] = useState<DailyVisit | null>(null);
    const [expandedVisitors, setExpandedVisitors] = useState<Set<string>>(new Set());

    const { isFetching, pagination, selectedSiteIds } = useSelector((state: CombinedStates) => state.securityDashboard);
    const dispatch = useDispatch<AppDispatch>();

    const toggleVisitorsExpansion = (recordId: string) => {
        const newExpanded = new Set(expandedVisitors);
        if (newExpanded.has(recordId)) {
            newExpanded.delete(recordId);
        } else {
            newExpanded.add(recordId);
        }
        setExpandedVisitors(newExpanded);
    };

    const renderVisitorNames = (visitors: string[], record: DailyVisit) => {
        const recordId = `${record.reference}-${record.startDate}`;
        const isExpanded = expandedVisitors.has(recordId);
        const maxVisibleVisitors = 3;
        const hasManyVisitors = visitors.length > maxVisibleVisitors;

        if (!visitors || visitors.length === 0) {
            return <div className="cell-content visitor-names">No visitors</div>;
        }

        if (!hasManyVisitors) {
            return (
                <div className="cell-content visitor-names">
                    {visitors.map((visitor, index) => (
                        <div key={`visitor-${recordId}-${index}`} className="visitor-item">
                            {visitor}
                        </div>
                    ))}
                </div>
            );
        }

        const visibleVisitors = isExpanded ? visitors : visitors.slice(0, maxVisibleVisitors);
        const remainingCount = visitors.length - maxVisibleVisitors;

        return (
            <div className="cell-content visitor-names">
                {visibleVisitors.map((visitor, index) => (
                    <div key={`visitor-${recordId}-${index}`} className="visitor-item">
                        {visitor}
                    </div>
                ))}
                {!isExpanded && remainingCount > 0 && (
                    <div
                        className="visitor-expand-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            toggleVisitorsExpansion(recordId);
                        }}>
                        +{remainingCount} more <DownOutlined />
                    </div>
                )}
                {isExpanded && (
                    <div
                        className="visitor-collapse-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            toggleVisitorsExpansion(recordId);
                        }}>
                        Show less <UpOutlined />
                    </div>
                )}
            </div>
        );
    };

    const handleRowClick = (record: DailyVisit) => {
        setModalData(record);
        setShowDetailsModal(true);
    };

    const handleCancel = () => {
        setShowDetailsModal(false);
    };

    const columns = [
        {
            title: 'Ref',
            dataIndex: 'reference',
            key: 'reference',
            render: (text: string) => <div className="cell-content">{text}</div>,
        },
        {
            title: 'Site',
            dataIndex: 'siteName',
            key: 'siteName',
            width: 200,
            render: (text: string) => <div className="cell-content">{text}</div>,
        },
        {
            title: 'Number of Visitors',
            dataIndex: 'visitorsCount',
            key: 'visitorsCount',
            // width: 50,
            render: (text: string) => <div className="cell-content">{text}</div>,
        },
        {
            title: 'Date & Shift',
            dataIndex: 'startDate',
            key: 'startDate',
            width: 300,
            render: (text: string, record: DailyVisit) => (
                <div className="cell-content">
                    <p style={{ margin: 0, fontWeight: 'bold' }}>{moment(text).format('D MMMM YYYY')}</p>
                    <p style={{ margin: 0 }}>{record.shift}</p>
                    <p style={{ margin: 0 }}>{record.timeSlot}</p>
                </div>
            ),
        },
        {
            title: 'Area Access',
            dataIndex: 'areaAccess',
            key: 'areaAccess',
            width: 180,
            render: (text: string) => <div className="cell-content">{text}</div>,
        },
        {
            title: 'Visitor Names',
            dataIndex: 'visitors',
            key: 'visitors',
            width: 300,
            render: (visitors: string[], record: DailyVisit) => renderVisitorNames(visitors, record),
        },
    ];

    return (
        <>
            <ViewDetailsModal
                open={showDetailsModal}
                handleCancel={handleCancel}
                data={modalData} />
            <div className="security-visit-list-container">
                <Table
                    loading={isFetching}
                    data={visitData}
                    columns={columns}
                    // paginationSize={20}
                    pagination={{
                        // defaultPageSize: pagination.pageSize,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        currentPage: pagination.currentPage,
                        onChange: (page: number) => {
                            dispatch(securityDashboardRequest({ page, siteIds: selectedSiteIds }));
                        },
                    }}
                    onRow={(record) => ({
                        onClick: () => {
                            handleRowClick(record);
                        },
                    })} />
            </div>
        </>

    );
};

export default SecurityVisitList;
